export default __webpack_public_path__ + "static/media/640_dummy2016-lebenslaufbusiness01.7d39efce.png";